// About.js
import React from 'react';
import { Typography } from '@mui/material';
import Mansion from '../1500x500.jpeg';

const Home = () => {
  return (
    <div>
      <table>
        <tr>
          <td>
            <h3>Welcome to the Republican Liberty Caucus of Virginia!</h3>
          </td>
        </tr>
        <tr>
          <td style={{padding: "16px", textAlign: "center", verticalAlign: "top"}}>
            <img src={Mansion} alt="Table Image" style={{maxWidth: "100%", height: "auto", display: "block"}} />
          </td>
        </tr>
      </table>
    </div>
  );
};

export default Home;